import { apiClient } from './client'
import type { Winner } from '@/shared/types'

function parseWinner(raw: Record<string, unknown>): Winner {
  return { ...raw, amount: parseFloat(raw.amount as string) } as Winner
}

export const winnersApi = {
  getAll: async (limit?: number): Promise<Winner[]> => {
    const { data } = await apiClient.get<Record<string, unknown>[]>('/winners', { params: limit ? { limit } : {} })
    return data.map(parseWinner)
  },

  getAfter: async (dealNumber: number, limit = 20): Promise<Winner[]> => {
    const { data } = await apiClient.get<Record<string, unknown>[]>(`/winners/after/${dealNumber}`, { params: { limit } })
    return data.map(parseWinner)
  },
}
